import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import styled from '@emotion/styled';
import TopBar from '../Home/TopBar';
import { useUserContext } from '../../context/UserContext';
import { useSearchParams } from '../../context/SearchParamsContext';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
import ProfilePage from './Profile/ProfilePage';
import UsersPage from './ClientUsers/UsersPage';
import CompanySettingsPage from './CompanySettings/CompanySettingsPage';
import axios from 'axios';
import AccountSettingsPage from './AccountSettings/AccountSettingsPage';
import { DropdownOption } from './types';
import Select from 'react-select';

const Tabs = styled.div`
  display: flex;
  justify-content: space-between;
  /* max-width: 1650px; */
  margin-left: 80px;
  margin-top: 40px;
  color: #8e8e93;
  cursor: pointer;
  width: 100%;
`;
const customStyles = {
  container: (provided: any, state: any) => ({
    ...provided,
    width: 280,
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    border: '1px solid #f5f5f5',
    height: 30,
  }),
};
const Section = styled.div<{ border?: boolean }>`
  border-bottom: ${props => (props.border ? '4px solid #333' : '#fff')};
  padding: 0 32px 16px 16px;
`;

const tabArray = [
  { value: 0, name: 'Company Info', route: 'info' },
  { value: 1, name: 'Company Settings', route: 'companysettings', accessLevel: 'Administrator' },
  { value: 2, name: 'Members', route: 'members', accessLevel: 'Administrator' },
  { value: 3, name: 'My Profile', route: 'myProfile' },
];

interface Props {}

const Settings = (props: Props) => {
  const { user } = useUserContext();
  const [showleaveModal, setShowLeaveModal] = useState(false);
  const [indexToSelect, setIndexToSelect] = useState(0);
  const [clientJvs, setClientJvs] = useState([]);
  const [selectedClient, setSelectedClient] = useState<DropdownOption>();

  const { tab } = useParams<{ tab: string }>();
  const searchParams = useSearchParams();
  const history = useHistory();

  useEffect(() => {
    if (tab) {
      const index = tabArray.findIndex(
        t => t.route === tab && (user.permission === t.accessLevel || !t.accessLevel)
      );
      setIndexToSelect(index > -1 ? index : 0);
    }
  }, [tab]);

  useEffect(() => {
    if (user.clientId)
      axios.get(`/api/clientaccount/getClientAndJvs/${user.clientId}`).then(({ data }) => {
        const mappedData = data.map(jv => ({ value: jv.id, label: jv.name }));
        setClientJvs(mappedData);
        setSelectedClient(mappedData.find(d => d.value === user.clientId));
      });
  }, [user?.clientId]);

  useEffect(() => {}, [selectedClient]);
  const clientName = user.clientName;
  const headerSearch = () => {
    const queryString = qs.stringify({
      open: searchParams.isTopSearchOpen ? 1 : 0,
      query: searchParams.topSearchText,
    });
    document.title = '';
    history.push(`/home?${queryString}`);
  };

  const closeDetailsSearch = () => {
    searchParams.setTopSearchText('');
    searchParams.setIsTopSearchOpen(false);
  };

  return (
    <div style={{ paddingBottom: 60 }}>
      <TopBar
        search={headerSearch}
        searchText={searchParams.topSearchText}
        onSearchTextChange={searchParams.setTopSearchText}
        setSearchOpen={searchParams.setIsTopSearchOpen}
        searchOpen={searchParams.isTopSearchOpen}
        info
        name={user.clientName}
        closeSearch={closeDetailsSearch}
        showLeaveModal={showleaveModal}
      />
      <div style={{ borderBottom: '2px solid #E5E5EA' }}>
        <div style={{ fontSize: 24, fontWeight: 700, marginTop: 64, marginLeft: 80 }}>Settings</div>
        <Tabs>
          <div style={{ display: 'flex' }}>
            {tabArray.map((ta, index) => {
              if(ta.accessLevel && ta.accessLevel !== user.permission){
                return null
              }
              return (
                <Section
                  border={index === indexToSelect}
                  onClick={() => {
                    //setIndexToSelect(index);
                    history.replace(`/settings/${ta.route}`);
                  }}
                >
                  {ta.name}
                </Section>
              );
            })}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginRight: 100, paddingBottom: 8 }}>
            {clientJvs.length > 1 && indexToSelect < 3 && (
              <>
                <div style={{ marginRight: 16 }}>Company</div>
                <Select
                  name="selectedClient"
                  value={selectedClient}
                  options={clientJvs}
                  onChange={client => setSelectedClient(client)}
                  styles={customStyles}
                  components={{
                    IndicatorSeparator: null,
                  }}
                />
              </>
            )}
          </div>
        </Tabs>
      </div>
      {indexToSelect === 0 && <ProfilePage clientId={selectedClient?.value || user.clientId} />}
      {indexToSelect === 1 && <CompanySettingsPage clientId={selectedClient?.value || user.clientId} />}
      {indexToSelect === 2 && <UsersPage clientId={selectedClient?.value || user.clientId} />}
      {indexToSelect === 3 && <AccountSettingsPage />}
    </div>
  );
};

export default Settings;
